import { render, staticRenderFns } from "./patrolCoverage.vue?vue&type=template&id=516cebfd&scoped=true"
import script from "./patrolCoverage.vue?vue&type=script&lang=js"
export * from "./patrolCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516cebfd",
  null
  
)

export default component.exports